import React, { useState } from "react";
import Logo from "../../assets/image/logo.png";
import footerLogo from "../../assets/image/full-logo.png";
import gmailIcon from "../../assets/image/Footer_email.png";
import facebookIcon from "../../assets/image/Footer_facebook.png";
import instaIcon from "../../assets/image/Footer_instagram.png";
import localFooterImg from "../../assets/image/Subscribe_image.png";
import phoneIcon from "../../assets/image/Footer_phone.png";
import quizImage from "../../assets/image/Asset-25.png";
import { Link } from "react-router-dom";
import WhatClientSayCarousel from "./Components/UI/WhatClientSayCarousel ";

import MyForm from "./Components/UI/MyForm";
import QuizStepper from "./Components/QuizStepper";
import SubscribeNow from "./local/stories/SubscribeNow";

export interface AppNotifyForm {
  user_name: string | null;
  email: string | null;
  phone: string | null;
}

const Footer = ({ activeSection = "realState" }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [data, setData] = useState({});
  const quizInputs = [
    { type: "text", placeholder: "Name", name: "user_name" },
    { type: "phone", placeholder: "Phone", name: "phone" },
    { type: "email", placeholder: "Email Address", name: "email" },
  ];

  // const footerLinks = [
  //   {
  //     heading: "Learn",
  //     links: [
  //       { to: "#", label: "About Us" },
  //       { to: "#", label: "Contact Us" },
  //       { to: "#", label: "FAQs" },
  //       { to: "#", label: "Leadership" },
  //       { to: "#", label: "Offices" },
  //       { to: "#", label: "Press & News" },
  //       { to: "#", label: "Investors" },
  //     ],
  //   },
  //   {
  //     heading: "Info",
  //     links: [
  //       { to: "#", label: "Privacy Policy" },
  //       { to: "#", label: "Terms of Use" },
  //       { to: "#", label: "Cookie Policy" },
  //       { to: "#", label: "Site Map" },
  //     ],
  //   },
  //   {
  //     heading: "Agents",
  //     links: [
  //       { to: "#", label: "Become a Milford Agent" },
  //       { to: "#", label: "Milford Academy" },
  //       { to: "#", label: "Login" },
  //     ],
  //   },
  // ];

  const socialMediaIcons = [
    {
      href:
        activeSection === "local"
          ? "https://www.facebook.com/milfordmag/"
          : "https://facebook.com/MilfordRealEstateNE",
      icon: facebookIcon,
      alt: "Facebook",
    },
    {
      href:
        activeSection === "local"
          ? "https://instagram.com/milfordlocal"
          : "https://instagram.com/milfordrealestatene/",
      icon: instaIcon,
      alt: "Instagram",
    },
    {
      href:
        activeSection === "local"
          ? "mailto:local@milford.com"
          : "mailto:concierge@milford.com",
      icon: gmailIcon,
      alt: "Email",
    },
    {
      href:
        activeSection === "local" ? "tel:+1402-718-7104" : "tel:+1402-880-0202",
      icon: phoneIcon,
      alt: "Phone",
    },
  ];
  const onFormSubmit = (userDetails, formtype) => {
    // console.log("Form Submit", userDetails, "and form type is ", formtype);
    setData(userDetails);
    setIsModalOpen(true);
  };
  const customStyle = activeSection === "" ? "90" : "";
  return (
    <>
      {/* {activeSection === "magazine" && (
        <div className="magazine">Hello magazine</div>
      )}
      {activeSection === "stories" && (
        <div className="stories">Hello Stories</div>
      )} */}
      {activeSection === "realState" && <WhatClientSayCarousel />}

      {activeSection === "realState" && (
        <div className=" container ">
          <div className="quiz-section ">
            <div className="row">
              <div className="col-md-6">
                <img src={quizImage} alt="" className="quiz-img img-fluid" />
              </div>
              <div className="col-md-6">
                <div className=" quize-form-section">
                  <MyForm
                    submitTxt={"TAKE QUIZ"}
                    fields={quizInputs}
                    onFormSubmit={(userDetails) =>
                      onFormSubmit(userDetails, "quiz")
                    }
                    isModalOpen={false}
                    inputClass="w-100 quiz-input"
                    btnClass="text-center"
                    justify="center"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {activeSection === "local" && <SubscribeNow />}

      <div
        className={`modal fade app-notify-modal quiz-modal ${isModalOpen ? "show" : null
          }`}
        id="quizModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => setIsModalOpen(false)}
            ></button>
            {isModalOpen && (
              <QuizStepper
                setIsModalOpen={setIsModalOpen}
                isModalOpen={isModalOpen}
                data={data}
              />
            )}
          </div>
        </div>
      </div>

      <footer
        className="footer-section"
        style={{ paddingBlock: `${customStyle}px` }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="logo-section d-flex align-items-center">
                <div className="footer-logo-img">
                  <img
                    height={"100px"}
                    src={activeSection === "realState" ? footerLogo : Logo}
                    alt=""
                  />
                </div>
                <div className="d-flex social-media-links">
                  {socialMediaIcons.map(({ href, icon, alt }) => (
                    <a
                      key={icon}
                      href={href}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={icon} alt={alt} />
                    </a>
                  ))}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="footer-links-container d-flex justify-content-end">
                {/* {footerLinks.map(({ heading, links }) => (
                  <div
                    key={heading}
                    className="link-section d-flex flex-column"
                  >
                    <h4 className="link-heading">{heading}</h4>
                    {links.map(({ to, label }) => (
                      <Link key={label} to={to}>
                        {label}
                      </Link>
                    ))}
                  </div>
                ))} */}
              </div>
            </div>
          </div>
        </div>
      </footer>
      {isModalOpen && <div className="modal-backdrop fade show"></div>}
    </>
  );
};

export default Footer;
